export function removeNoJsClass() {
  document.documentElement.classList.remove('no-js');
}
